import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconColorPicker = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M20.11 4.39c.593.594.89 1.32.89 2.18 0 .844-.297 1.563-.89 2.157l-3.024 3 1.617 1.64a.767.767 0 0 1 .235.563.847.847 0 0 1-.235.586.795.795 0 0 1-.586.234.767.767 0 0 1-.562-.234l-1.617-1.641-8.297 8.297a.98.98 0 0 1-.352.258c-.125.047-.266.07-.422.07H4.078a1.1 1.1 0 0 1-.773-.305A1.099 1.099 0 0 1 3 20.422v-2.79c0-.155.023-.296.07-.421a.979.979 0 0 1 .258-.352l8.297-8.297-1.64-1.617a.767.767 0 0 1-.235-.562c0-.235.078-.43.234-.586a.847.847 0 0 1 .586-.234c.22 0 .407.078.563.234l1.64 1.617 3-3.023A2.937 2.937 0 0 1 17.93 3.5c.86 0 1.586.297 2.18.89zM6.655 19.884l8.11-8.11-2.04-2.039-8.109 8.11v2.039h2.04z" }),
});

export { IconColorPicker };
